import { useEffect} from "react";
import { useSearchParams,useNavigate } from "react-router-dom";

const DocusignReponse = () => {
    const [searchParams] = useSearchParams ()
    const navigate = useNavigate()
    const eventParam = searchParams.get('event');

useEffect(() => {
    if(eventParam) {
        localStorage.setItem('docusignStatus',eventParam)
        navigate(`/Settings?event=${eventParam}`)
    }

},[eventParam])

}

export default DocusignReponse